import React from "react";
import "./header.scss";
import { Dropdown } from "react-bootstrap";
import Navigation from "../nav/nav";
import Globals from "../../api";
import SearchWidget from "../SearchWidget/Searchwidget";
export default class Header extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      headerData: [],
      language: [],
      languages: [],
      electionSettingsData : []
    };
  }
  getLanguage() {
    const LanguageAPI = Globals.language_based_api;
    //console.log(LanguageAPI)
    fetch(LanguageAPI)
      .then((res) => res.json())
      .then((data) => {
        //console.log(data)
        this.setState({
          language: data.Contents[0].Language,
          languages: data.Contents[0].Languages,
        });
      });
  }
  getElectionSettingsData(){
    const url= "https://nonprod-media.webdunia.com/public_html/_media/election/loksabha/json/loksabha-election-setting.json";
    
    fetch(url)
    .then((res) => res.json())
    .then((data) => {
        this.setState({
          electionSettingsData : data.ExitPollUrl
          
        })
    })   
  }
  componentDidMount() {
    const HeaderConurl = Globals.Desktop_header_based_api;
    // console.log(HeaderConurl)
    fetch(HeaderConurl)
      .then((res) => res.json())
      .then((data) => {
        //console.log(data)
        this.setState({
          headerData: data.NavigationMenu.Items,
        });
      });
    this.getLanguage();
    this.getElectionSettingsData();
  }

  render() {
  
    //language
    let _languagename = this.state.language;
    let _languageSlider = this.state.languages;
    //date
    var options = {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    };
    var today = new Date();
    //toggle

    // const LangNames = _languageSlider.map((item , i)  =>

    // <li key = {i} ><a href='#' title={item.Code} languageCode={item.Name} >{item.Name}</a></li>
    //   );

    let _navmenu = this.state.headerData;
    const NavMenu = _navmenu.map((item, i) => (
      <ul className="dropdown_menslink" key={i}>
        <h3>
          <a href={item.DefaultUrl}>{item.Text}</a>
        </h3>

        {item.Items.map((item, i) => (
          <li id={i} key={i}>
            <a href={item.DefaultUrl}>{item.Text}</a>
          </li>
        ))}
      </ul>
    ));
    const LangNames = _languageSlider.map((item, i) => (
      <li key={i} className={item.Code}>
        <a
          className={_languagename.Name == item.Name ? "active" : ""}
          href={item.Site}
          title={item.Name}
          languagecode={item.Code}
        >
          {item.Name}
        </a>
      </li>
    ));

    return (
      <>
      <div className="header_section">
        <div className="h_top_sect">
          <div className="container">
            <div className="h_top_block">
              <div className="wd_date">
                {today.toLocaleDateString(Globals.LanguageCode+'-IN', options)}
              </div>
              <div className="wd_lang">
                <ul>
                  <li>
                    <span>Choose your language</span>
                  </li>
                  {LangNames}
                </ul>
              </div>
              <div className="h_top_rightsect">
                <ul className="wd_social_link">
                  <li>
                    <span>Follow us</span>
                  </li>
                  <li className="fb_icon">
                    <a title="facebook" alt="facebook" href="https://www.facebook.com/WdTamil/"  target="_blank"></a>
                  </li>
                  <li className="tw_icon">
                    <a title="twitter" alt="twitter" href="https://twitter.com/webduniaTamil/" target="_blank"></a>
                  </li>
                  <li className="int_icon">
                    <a title="instagram" alt="instagram" href="https://www.instagram.com/webdunia.tamil/"  target="_blank"></a>
                  </li>
                  <li className="yout_icon">
                    <a title="youtube" alt="youtube" href="https://www.youtube.com/channel/UCxFIiFdLJaTcNBfQYTiLElw"  target="_blank"></a>
                  </li>
                </ul>
                {/* <div className="h_search">
                  <a href="#"></a>
                </div> */}
              </div>
            </div>
          </div>
        </div>

        <div className="header_sect">
          <div className="container">
            <div className="h_left_col">
              <div className="m_bar">
                <Dropdown>
                  <Dropdown.Toggle aria-label="Menu Bar">
                    <div className="menu_hambur">
                      <span className="m_hamb1"></span>
                      <span className="m_hamb2"></span>
                      <span className="m_hamb3"></span>
                    </div>
                  </Dropdown.Toggle>

                  <Dropdown.Menu>{NavMenu}</Dropdown.Menu>
                </Dropdown>
              </div>
              <div className="wd_logo">
                <a href="/">
                    <img width="125" height="65" title="webdunia logo" alt="webdunia logo"
                      loading="lazy"
                      src={require("../../assets/img/logo/ta-logo.svg").default}
                    />
                </a>
              </div>
            </div>

            <div className="h_mid_col">
              <div className="h_menu_sect">
                <Navigation />
              </div>
            </div>

            <div className="h_right_col">
              <div className="h_search_apps">
                <SearchWidget />
                <ul>
                  <li>
                    <a title="Play store" alt="Play store"
                      href="https://play.google.com/store/apps/details?id=com.webdunia.app&hl=en"
                      className="playstore_icon" target="_blank"
                    ></a>
                  </li>
                  <li>
                    <a title="itunes" alt="itunes"
                      href="https://apps.apple.com/in/app/webdunia/id1599507309"
                      className="apple_icon" target="_blank"
                    ></a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* <Nav /> */}
      </div>
      </>
    );
  }
}
